import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class UpsellAutomationService {
  createUpdateTrigger(data) {
    return axios.post(`${API_URL}upsell/create-update-trigger`, data, {
      headers: authHeader(),
    });
  }
  fetchTriggersByStore(shopifyStoreId) {
    return axios.get(
      `${API_URL}upsell/fetch-triggers-by-store/${shopifyStoreId}`,
      { headers: authHeader() }
    );
  }
  fetchTriggerById(id) {
    return axios.get(`${API_URL}upsell/fetch-trigger-by-id/${id}`, {
      headers: authHeader(),
    });
  }
  updateSingleColumn(data) {
    return axios.post(
      `${API_URL}upsell/update-single-column-in-trigger`,
      data,
      {
        headers: authHeader(),
      }
    );
  }

  deleteUpsellTrigger(id, shopifyStoreId) {
    return axios.delete(
      `${API_URL}upsell/delete-upsell-trigger/${id}/${shopifyStoreId}`,
      {
        headers: authHeader(),
      }
    );
  }

  fetchUpsellLogs(data){
    return axios.post(`${API_URL}upsell/logs`, 
    data,
    {
      headers: authHeader(),
    }
    )
  }
}

export default new UpsellAutomationService();
